export const EDUCATION_LEVELS = [
  { code: 'cap_bep', label: 'CAP / BEP' },
  { code: 'baccalaureate', label: 'Baccalauréat' },
  { code: 'bac_plus_2', label: 'Bac +2' },
  { code: 'bac_plus_3', label: 'Bac +3' },
  { code: 'bac_plus_4', label: 'Bac +4' },
  { code: 'bac_plus_5', label: 'Bac +5' },
  { code: 'doctorate', label: 'Doctorat' },
  { code: 'professional_title', label: 'Titre professionnel' },
  { code: 'certification', label: 'Certification' },
  { code: 'other', label: 'Autre' },
];

// Older development records may contain the French label instead of the API code.
export const normalizeEducationLevel = value => EDUCATION_LEVELS.find(level => level.code === value || level.label === value)?.code || value;
export const formatEducationLevel = value => EDUCATION_LEVELS.find(level => level.code === normalizeEducationLevel(value))?.label || value;
